// extracted by mini-css-extract-plugin
export default {"titulo":"Titulo_titulo__wKyck","divTitulo":"Titulo_divTitulo__rbCi3","h3":"Titulo_h3__8iekW","dadosAut":"Titulo_dadosAut__ahX7z"};